import { useContext, ssrRef } from '@nuxtjs/composition-api'
import { useLoading } from './ui/useLoading'
import { NewsCategory } from '~/types/blog'

export const rootNewsCategoryName = 'blogs'
const highlightCategoryName = 'uitgelicht'

const getNewsCategoriesLoading = useLoading()
const getHighlightCategoryLoading = useLoading()

const newsCategories = ssrRef<NewsCategory[] | null>(null)
const highlightCategory = ssrRef<NewsCategory | null>(null)

export const useBlog = () => {
  const { $api } = useContext()

  const getNewsCategories = () => {
    return getNewsCategoriesLoading.scope(async () => {
      const result = await $api.blog.getNewsCategoryByName(
        rootNewsCategoryName
      )
      if (result && result.childCategories.length) {
        const data: NewsCategory[] = []
        await Promise.all(
          result.childCategories.map(async category => {
            const response = await $api.blog.getNewsCategoryByName(category.name)
            if(response) {
              data.push({
                ...response,
                name: category.name,
                title: category.title,
                url: category.url
              })
            }
          })
        );
        newsCategories.value = data.sort((a:any, b:any) => a.name.localeCompare(b.name))
      }
    })
  }

  const ensureNewsCategories = async () => {
    if (newsCategories.value) return
    await getNewsCategories()
  }

  const getHighlightCategory = () => {
    return getHighlightCategoryLoading.scope(async () => {
      highlightCategory.value = await $api.blog.getNewsCategoryByName(
        highlightCategoryName,
        {
          ordered: true,
        }
      )
    })
  }

  const ensureHighlightCategory = async () => {
    if (highlightCategory.value) return
    await getHighlightCategory()
  }

  return {
    getNewsCategoriesLoading: getNewsCategoriesLoading.value,
    getHighlightCategoryLoading: getHighlightCategoryLoading.value,

    newsCategories,
    highlightCategory,

    getNewsCategories,
    ensureNewsCategories,

    getHighlightCategory,
    ensureHighlightCategory,
  }
}
